import React from 'react';
import Modal from './Modal';
import SubscribeForm from './SubscribeForm';

// Market Notes signup in the shared Modal. The same SubscribeForm powers this and the
// /subscribe page (`compact` drops the page-only portrait + copyright).
function SubscribeModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} labelledBy="subscribe-modal-title">
      <p className="app-modal-eyebrow">Market Notes</p>
      <h2 id="subscribe-modal-title" className="app-modal-title">Join the Newsletter</h2>
      <p className="app-modal-sub">
        A few thoughtful emails a month on the Bay Area market. No noise, no pressure.
      </p>
      <SubscribeForm compact />
    </Modal>
  );
}

export default SubscribeModal;
